import React, { Component } from 'react'
import { connect } from 'react-redux'
import { History } from 'history'

import { selectAdmin, selectCurrentUserBadges } from '../../reducers'
import { AdminBanner } from './adminBanner'
import AdminBadgesForm from './adminBadgesForm'

import { updateAdminBadges, fetchAdmin } from './adminActions'
import { User } from '../../core/types'
import Breadcrumb from '../../components/Breadcrumb'
import LoadingSection from '../../components/loadingSection'

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  fetchAdmin: Callback
  updateAdminBadges: Callback<Promise<any>>
  admin: User
  canAssignSuperuser: boolean
  match: Match<ParamsID>
  history: History
}

export class AdminProfile extends Component<Props> {
  static displayName = 'AdminProfile'

  componentWillMount() {
    this.fetchAdminData()
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props
    if (match.params.id !== prevProps.match.params.id) {
      this.fetchAdminData()
    }
  }

  fetchAdminData = () => {
    const { fetchAdmin, match } = this.props
    fetchAdmin(match.params.id)
  }

  onSubmit = (values) => {
    const { history, updateAdminBadges, admin } = this.props

    return updateAdminBadges(admin.id, values.badges).then(() => {
      history.push({ pathname: '/admins' })
    })
  }

  onCancel = () => {
    this.props.history.push({ pathname: '/admins' })
  }

  render() {
    const { admin, canAssignSuperuser } = this.props

    if (!admin.id) return null
    const { badges } = admin

    const levels = [
      { label: 'Index ', path: '/' },
      { label: 'Admins', path: '/admins' },
    ]

    return (
      <>
        <Breadcrumb levels={levels} />
        <LoadingSection isLoading={!admin.id}>
          <div className="admin-profile">
            <AdminBanner user={admin} context="Admin" />
            <AdminBadgesForm
              onSubmit={this.onSubmit}
              cancel={this.onCancel}
              initialValues={{ badges }}
              canAssignSuperuser={canAssignSuperuser}
            />
          </div>
        </LoadingSection>
      </>
    )
  }
}

export const mapStateToProps = (state, { match }) => {
  return {
    admin: selectAdmin(state.adminUsers, match.params.id),
    canAssignSuperuser: (selectCurrentUserBadges(state) || []).includes(
      'SUPERUSER'
    ),
  }
}

export default connect(mapStateToProps, {
  fetchAdmin,
  updateAdminBadges,
})(AdminProfile)
